<smrts-dialog [title]="title" [hasFootnote]="true">

  <div class="content custom-table">

    <div class="custom-table-row">
      <div class="custom-table-col two-column-width">
        <p-floatlabel variant="on">
          <input pInputText fluid [(ngModel)]="nomeFinal" />
          <label>Nome final</label>
        </p-floatlabel>
      </div>
    </div>

    <div class="custom-table-row">
      <div class="custom-table-col two-column-width">
        <p-table [value]="tipos" [scrollable]="true" scrollHeight="240px">
          <ng-template pTemplate="header">
            <tr>
              <th>Tipos que serão mesclados ({{ tipos.length }})</th>
              <th>Lançamentos</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tipo>
            <tr>
              <td>{{ tipo.nome }}</td>
              <td>{{ tipo.quantidadeLancamentos }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()">
      Salvar
    </button>
  </div>
</smrts-dialog>
